import {
  getChannelContextAdditionalInfo,
  getChannelContextCode,
  getFirstAuthorizationMode,
  isObjectEmpty
} from 'helpers/Utility';
import { setError, setNewPhoneNo } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

const isRayaUser = auth =>
  auth.subCode === 'RAYA' && !isObjectEmpty(auth.dataRayaAppsAuthFlow);

/**
 * Main function to handle update phone number error
 * @param {*} err
 * @param {*} dispatch
 * @param {*} auth
 * @param {*} param
 * @param {*} action
 * @returns
 */
export const handleErrorUpdatePhoneNumber = (err, dispatch, auth, action) => {
  const addInfo = getChannelContextAdditionalInfo(err, 'channel-context');
  const freezeTime = addInfo?.freezeEnd;
  if (!err.response) {
    dispatch(setError('connection_change_number'));
    return;
  }

  const code = getChannelContextCode(err, 'channel-context');
  const status = err?.response?.status;

  if (code === null) {
    dispatch(setError('system_change_number'));
    return;
  }

  if (code === '5000209') {
    dispatch(setError('photo_does_not_match'));
    return;
  }

  if (code === '4010000') {
    action?.navigateLiveness?.();
    return;
  }

  if (code === '4032301' || code === '4000210') {
    dispatch(setError('not_eligible_face_compare'));
    return;
  }

  if (code === '4032300') {
    dispatch(setError('change_number_quota_exceeded'));
    return;
  }

  // ---- 401 ----
  if (status === 401) {
    const mode = getFirstAuthorizationMode(err, 'channel-context');

    if (mode === 'OTP') {
      const newPhone = isRayaUser(auth)
        ? auth.phoneNoRaya
        : auth.newPhoneNumber;

      dispatch(setNewPhoneNo(newPhone));
      action?.success?.();
      return;
    }
  }

  // ---- 400 ----
  if (status === 400) {
    const handlers = {
      107880: () => {
        dispatch(setError('number-registered'));
        action?.failed?.(err.response);
      },
      211149: () => {
        dispatch(setError('number-not-exist'));
      },
      100879: () => {
        if (freezeTime) {
          localStorage.setItem('otpFreeze', JSON.stringify({ freezeTime }));
          dispatch(setError('temporary_locked'));
          dispatch(loading(false));
          return;
        }

        action?.eventName?.(err.response);
        action?.failed?.();
        dispatch(setError('incorrect_otp'));
      },
      105412: () => {
        dispatch(setError('otp-expired'));
      },
      4000101: () => {
        dispatch(setError('number-registered-other-account'));
        action?.failed?.(err.response);
      },

      4000004: () => {
        dispatch(setError('number-already-used'));
        action?.failed?.(err.response);
      },
      4000301: () => {
        localStorage.setItem('otpFreeze', JSON.stringify({ freezeTime }));
        dispatch(setError('otp_temporary_locked'));
        action?.limitSendOtp?.();
      },
      4000300: () => {
        action?.eventName?.(err.response);
        action?.failed?.();
        dispatch(setError('incorrect_otp'));
      },
      4000203: () => {
        action?.limitReceiveOtp?.();
      },
      405203: () => {
        dispatch(setError('otp-expired'));
      }
    };

    if (handlers[code]) {
      handlers[code]();
      return;
    }
  }

  dispatch(setError('system_change_number'));
};
